import { createAction } from 'redux-actions'
import * as types from 'Redux/Types/UserManagementTypes'

export const addUser = createAction(types.ADD_USER)
export const addUserFailed = createAction(types.ADD_USER_FAILED)
export const addUserSucceeded = createAction(types.ADD_USER_SUCCEEDED)
export const deactivateUsers = createAction(types.DEACTIVATE_USERS)
export const deactivateUsersFailed = createAction(types.DEACTIVATE_USERS_FAILED)
export const deactivateUsersSucceeded = createAction(types.DEACTIVATE_USERS_SUCCEEDED)
export const fetchManagedUsers = createAction(types.FETCH_MANAGED_USERS)
export const fetchManagedUsersFailed = createAction(types.FETCH_MANAGED_USERS_FAILED)
export const fetchManagedUsersSucceeded = createAction(types.FETCH_MANAGED_USERS_SUCCEEDED)
export const fetchUserRoles = createAction(types.FETCH_USER_ROLES)
export const fetchUserRolesFailed = createAction(types.FETCH_USER_ROLES_FAILED)
export const fetchUserRolesSucceeded = createAction(types.FETCH_USER_ROLES_SUCCEEDED)
export const registerManagedUser = createAction(types.REGISTER_MANAGED_USER)
export const registerManagedUserFailed = createAction(types.REGISTER_MANAGED_USER_FAILED)
export const registerManagedUserSucceeded = createAction(types.REGISTER_MANAGED_USER_SUCCEEDED)
export const resendUserInvite = createAction(types.RESEND_USER_INVITE)
export const resendUserInviteFailed = createAction(types.RESEND_USER_INVITE_FAILED)
export const resendUserInviteSucceeded = createAction(types.RESEND_USER_INVITE_SUCCEEDED)
export const updateManagedUser = createAction(types.UPDATE_MANAGED_USER)
export const updateManagedUserFailed = createAction(types.UPDATE_MANAGED_USER_FAILED)
export const updateManagedUserSucceeded = createAction(types.UPDATE_MANAGED_USER_SUCCEEDED)
